export { default } from './part-footer';
